import axios from "../../lib/axios";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useMutation } from '@tanstack/react-query'

export const useGetLivePriceBingold = () => {
    return useQuery({
        queryKey: ["bigodLivePrice"],
        queryFn: async () => {
            const response = await axios.get("https://bingold.to/api/buy/token-price-conversion");
            return response.data;
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch data");
        },
    });
};

// blog api
// Response shape: { success, message, data: { total, page, totalPages, blogs: [...] } }
// We pick out the inner `data` object so components can use data.blogs / data.total / data.totalPages directly.
export const useGetBlogData = ({ page = 1, limit = 12, blogType = 'bingold' } = {}) => {
    return useQuery({
        queryKey: ["blogData", page, limit, blogType],
        queryFn: async () => {
            const response = await axios.post("/blogs", { page, limit, blogType }, { params: { page, limit } });
            const body = response?.data ?? {};
            const inner = body?.data ?? {};
            const items = Array.isArray(inner?.blogs)
                ? inner.blogs
                : Array.isArray(inner?.result)
                    ? inner.result
                    : Array.isArray(inner?.data)
                        ? inner.data
                        : [];
            const total = Number(inner?.total ?? inner?.totalRecords ?? items.length ?? 0);
            const totalPages = Number(
                inner?.totalPages ?? (limit > 0 ? Math.max(1, Math.ceil(total / limit)) : 1)
            );
            return { items, total, totalPages };
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch data");
        },
    });
};



export const useGetBlogDetail = () => {
    return useMutation({
        mutationKey: ["useGetBlogDetail"],
        mutationFn: async ({ slug, blogType = 'bingold' }) => {
            const response = await axios.post('/blogs/' + slug, { blogType });
            return response.data;
        }
    });
}


// news api
// Response shape: { success, message, data: { total, page, totalPages, data: [...] } }
export const useGetNewsData = ({ page = 1, limit = 12, newsType = 'bingold' } = {}) => {
    return useQuery({
        queryKey: ["newsData", page, limit, newsType],
        queryFn: async () => {
            const response = await axios.post("/news", { page, limit, newsType }, { params: { page, limit } });
            const body = response?.data ?? {};
            const inner = body?.data ?? {};
            const items = Array.isArray(inner?.data)
                ? inner.data
                : Array.isArray(inner?.news)
                    ? inner.news
                    : Array.isArray(inner?.result)
                        ? inner.result
                        : [];
            const total = Number(inner?.total ?? inner?.totalRecords ?? items.length ?? 0);
            const totalPages = Number(
                inner?.totalPages ?? (limit > 0 ? Math.max(1, Math.ceil(total / limit)) : 1)
            );
            return { items, total, totalPages };
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch data");
        },
    });
};

export const useGetNewsDetail = () => {
    return useMutation({
        mutationKey: ["getNewsDetail"],
        mutationFn: async ({ slug, newsType = 'bingold' }) => {
            const response = await axios.post('/news/' + slug, { newsType });
            return response.data;
        }
    });
}
